import { Avatar, AvatarImage, AvatarFallback } from '@radix-ui/react-avatar'
import { useAuth } from '@/lib/auth.context'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { Search, User, LogOut, ChevronDown, Moon, Sun, Globe, Settings  } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../lib/theme-context'
import { useState } from 'react';
import { ProfileSettingModal } from '@/components/user/ProfileSettingModal';
//import { useUserProfile } from '@/hooks/useUserProfile';


function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <Button variant="outline" className="hover:bg-transparent" size="icon" onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}

export function Header() {
  const { user, status, logout } = useAuth()
  const { t } = useTranslation()

  const handleLogout = async () => {
    await logout(true)
  }

  if (status === 'loading') return <div className="h-16" />

  if (!user) {
    return null
  }

  const getInitials = (name: string) => {
    const nameParts = name.split(' ').filter(Boolean)
    if (nameParts.length === 0) return '??'
    if (nameParts.length === 1) return nameParts[0].substring(0, 2).toUpperCase()

    const firstInitial = nameParts[0].charAt(0)
    const lastInitial = nameParts[nameParts.length - 1].charAt(0)
    return `${firstInitial}${lastInitial}`.toUpperCase()
  }

  const firstName = user.user_metadata?.first_name
  const lastName = user.user_metadata?.last_name


  const fullName = [firstName, lastName].filter(Boolean).join(' ') || 'Partner User'
  const initials = getInitials(fullName)
  const email = user?.email


  const [searchQuery, setSearchQuery] = useState('');

  const [showUserDetail, setShowUserDetail] = useState(false);



  return (
    <header className="h-header bg-card border-b border-border flex items-center justify-between px-6">
      {/* Search Bar */}
      <div className="hidden md:block flex-1 max-w-md mx-8">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2 bg-background border border-input rounded-lg focus:outline-none ring-ring ring-1 focus:ring-2 focus:ring-ring focus:border-transparent"
          />
        </div>
      </div>
      {/* Right Section */}
      <div className="flex w-full md:w-auto justify-between w-full items-center gap-4">
        {/* Theme Toggle */}
        <ThemeToggle />
        {/* Notifications */}
        {/*<NotificationPopover />*/}

        {/* User Profile */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-3 px-1 md:px-3 py-2 h-auto">
              <div className="h-8 w-8 bg-primary rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-primary-foreground">
                  {initials}
                </span>
              </div>
              <div className="hidden md:block text-left">
                <div className="text-sm font-medium">{fullName}</div>
                <div className="text-xs text-muted-foreground">{email}</div>
              </div>
              <ChevronDown className="h-4 w-4 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => { setShowUserDetail(true);}}>
              <Settings className="mr-2 h-4 w-4" />
              <span>Settings</span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              <span>Sign out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* User Detail Modal */}
      <ProfileSettingModal
        open={showUserDetail}
        onClose={() => {
          setShowUserDetail(false);
        }}
      />
    </header>
  )
}
